import { render, staticRenderFns } from "./MenuLancamento.vue?vue&type=template&id=68419274&"
import script from "./MenuLancamento.vue?vue&type=script&lang=js&"
export * from "./MenuLancamento.vue?vue&type=script&lang=js&"
import style0 from "./MenuLancamento.vue?vue&type=style&index=0&id=68419274&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports